// extracted by mini-css-extract-plugin
module.exports = {"about":"AboutUs_about__t6l_j","thankYou":"AboutUs_thankYou__hGsrE"};